(function () {
  'use strict';
  if (window.__bfCartBound) return;
  window.__bfCartBound = true;
  // Safari may give the dialog's auto-focused close button a focus-visible ring.
  // Suppress that ring only after pointer input; keyboard navigation keeps it.
  function pointerInput() { document.documentElement.dataset.bfInput = 'pointer'; }
  document.addEventListener('pointerdown', pointerInput, true);
  document.addEventListener('touchstart', pointerInput, { capture: true, passive: true });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Tab' || event.key.indexOf('Arrow') === 0) document.documentElement.dataset.bfInput = 'keyboard';
  }, true);
  // The reference wipes in from below and continues upward when the pointer leaves.
  var hoverButtons = '.bf-pc-actions__buy:not([data-bf-notify-disabled]), .bf-pc-nav__buy:not([data-bf-notify-disabled])';
  document.addEventListener('pointerover', function (event) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches || event.pointerType === 'touch') return;
    var button = event.target.closest(hoverButtons);
    if (button && (!event.relatedTarget || !button.contains(event.relatedTarget))) button.dataset.bfHover = 'in';
  });
  document.addEventListener('pointerout', function (event) {
    var button = event.target.closest(hoverButtons);
    if (button && button.dataset.bfHover === 'in' && (!event.relatedTarget || !button.contains(event.relatedTarget))) {
      button.style.setProperty('--bf-wipe-out-y', getComputedStyle(button, '::before').getPropertyValue('--bf-wipe-y'));
      button.dataset.bfHover = 'out';
    }
  });
  var cartBusy = false;

  function shopRoot() {
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  }

  async function cartRequest(path, body) {
    var response = await fetch(shopRoot() + path, {
      method: body === undefined ? 'GET' : 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: body === undefined ? undefined : JSON.stringify(body)
    });
    var data = await response.json();
    if (!response.ok || data.errors || data.status >= 400) {
      throw new Error(data.description || data.message || 'Unable to add this item. Please try again.');
    }
    return data;
  }

  function sectionIds() {
    var onCart = (window.location.pathname || '').indexOf('/cart') !== -1;
    var mini = document.querySelector('xo-cart-mini');
    var cart = document.querySelector('xo-cart');
    if (window.Xotiny) {
      if (onCart) return [cart && cart.id, mini && mini.id].filter(Boolean);
      if (mini && mini.id) return [mini.id];
    }
    return onCart ? [] : ['cart-drawer', 'cart-icon-bubble'];
  }

  function setBusy(on) {
    document.querySelectorAll('[data-bf-buy-now], [data-bf-add-to-cart]').forEach(function (button) {
      if (on) {
        button.dataset.bfWasDisabled = button.disabled ? 'true' : 'false';
        button.setAttribute('aria-busy', 'true');
        if (button.tagName === 'BUTTON') button.disabled = true;
      } else {
        button.removeAttribute('aria-busy');
        if (button.tagName === 'BUTTON' && button.dataset.bfWasDisabled !== undefined) button.disabled = button.dataset.bfWasDisabled === 'true';
        delete button.dataset.bfWasDisabled;
      }
    });
  }

  async function renderedSections(ids) {
    if (!ids.length) return {};
    var response = await fetch(shopRoot() + '?sections=' + encodeURIComponent(ids.join(',')), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) return {};
    return response.json();
  }

  async function openCart(added) {
    var cart;
    try { cart = await cartRequest('cart.js'); } catch (_) { cart = added; }
    var ids = sectionIds();
    var sections = Object.assign({}, ((window.xoStore && window.xoStore.get && window.xoStore.get('xo-cart')) || {}).sections || {});
    Object.keys((added && added.sections) || {}).forEach(function (key) {
      if (typeof added.sections[key] === 'string' && added.sections[key]) sections[key] = added.sections[key];
    });
    var mini = document.querySelector('xo-cart-mini');
    if (mini && mini.id && typeof sections[mini.id] !== 'string') {
      try {
        var fresh = await renderedSections(ids);
        Object.keys(fresh).forEach(function (key) { if (typeof fresh[key] === 'string' && fresh[key]) sections[key] = fresh[key]; });
      } catch (_) {}
    }
    if (window.xoStore && typeof window.xoStore.set === 'function') {
      window.xoStore.set('xo-cart', function (previous) {
        return Object.assign({}, previous || {}, {
          size: typeof cart.item_count === 'number' ? cart.item_count : (previous || {}).size,
          sections: sections,
          item: added,
          isAdded: true,
          addIdLoading: '',
          changeLineLoading: -1
        });
      })('bf-atc');
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var trigger = document.querySelector('xo-modal-trigger[xo-name="cart"]');
    if (trigger) setTimeout(function () { trigger.click(); }, 300);
    else window.location.assign(shopRoot() + 'cart');
  }

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-bf-buy-now], [data-bf-add-to-cart]');
    if (!button) return;
    event.preventDefault();
    if (button.hasAttribute('data-bf-buy-now')) {
      button.classList.add('is-pressed');
      window.setTimeout(function () { button.classList.remove('is-pressed'); }, 320);
    }
    if (cartBusy || button.disabled) return;
    var buyNow = button.hasAttribute('data-bf-buy-now');
    var variant = button.getAttribute(buyNow ? 'data-bf-buy-now' : 'data-bf-add-to-cart');
    var fallback = button.getAttribute('data-bf-fallback') || button.getAttribute('href');
    if (!/^\d+$/.test(variant || '')) {
      if (fallback) window.location.assign(fallback);
      return;
    }
    var card = button.closest('article') || button.closest('.bf-m-actions') || button.parentElement;
    var status = card.querySelector('.bf-cart-error');
    if (status) status.remove();
    var discountApi = window.PongbotBfDiscount;
    if (buyNow && discountApi && typeof discountApi.hold === 'function') discountApi.hold(true);
    cartBusy = true;
    setBusy(true);
    try {
      // Match the Fall Prime Time Buy Now flow: checkout contains the selected variant.
      // Hold pauses BF code sync so clear/add is not paired with a discount write.
      // Checkout navigation flushes the code after gift sync.
      if (buyNow) await cartRequest('cart/clear.js', {});
      var body = { id: Number(variant), quantity: 1 };
      var ids = sectionIds();
      if (ids.length) { body.sections = ids; body.section_url = window.location.pathname || '/'; }
      var added = await cartRequest('cart/add.js', body);
      if (buyNow) window.location.assign(shopRoot() + 'checkout');
      else await openCart(added);
    } catch (error) {
      if (buyNow && discountApi && typeof discountApi.hold === 'function') discountApi.hold(false);
      status = document.createElement('p');
      status.className = 'bf-cart-error';
      status.setAttribute('role', 'alert');
      status.textContent = error.message || 'Unable to add this item. Please try again.';
      card.appendChild(status);
    } finally {
      cartBusy = false;
      setBusy(false);
    }
  });
  window.addEventListener('pageshow', function () { cartBusy = false; setBusy(false); });
})();
